<app-graph-configuration [data]="graphConfigData"/>


<ng-template #buttonTemplate> 
  <button 
    mat-flat-button
    (click)="closeDialog()"
  >
    Cancel
  </button>

  @let _validationErrors = validationErrors | async;
  <button
    [disabled]="!_validationErrors || _validationErrors.length > 0"
    [matTooltip]="_validationErrors ? _validationErrors[0] : ''"
    mat-flat-button
    color="primary"
    (appButtonClick)="$event.waitFor(_onSave())"
    data-cy="graph_configuration_dialog__save_button"
  >
    Save
  </button>
</ng-template>
